import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const TimeToHireTech: React.FC = () => {
  const { t } = useI18n('state-of-hiring');
  const { locale } = useRouter();

  const GRAPH_02_TIME_TO_HIRE_BY_TECH = [
    { label: 'Python', value: 61 },
    { label: 'AWS', value: 56 },
    { label: 'Angular', value: 56 },
    { label: 'React', value: 52 },
    { label: 'JavaScript', value: 49 },
    { label: 'Vue.js', value: 48 },
    { label: locale === 'es' ? 'Otros' : 'Other', value: 48 },
    { label: 'Ruby', value: 46 },
    { label: 'PHP', value: 44 },
    { label: 'JAVA', value: 40 },
    { label: '.NET', value: 40 },
    { label: 'Node.js', value: 37 }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={384}>
          <BarChart data={GRAPH_02_TIME_TO_HIRE_BY_TECH} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
            />
            <YAxis
              type="category"
              dataKey="label"
              tickLine={false}
              width={100}
            />
            <Tooltip
              cursor={{ fill: '#dffffd' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [
                value + ' ' + t('state-of-hiring.time-to-hire.days'),
                ''
              ]}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="#147092" barSize={12} radius={6} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default TimeToHireTech;
